import { Component } from "@angular/core";

@Component({
  selector: "app-course-registration",
  templateUrl: "./course-registration.component.html",
  styleUrls: ["./course-registration.component.css"],
})
export class CourseRegistrationComponent {
  courses = [
    {
      ref_no: "SOCI003-00",
      title: "New Energy Saving Technologies, Evidence-based Verification Methods and Related Practical Implementation Trends in Modern Building Energy Engineering (Zoom)",
      description:
        "With tightening regulatory requirements on building energy efficiency and increasing scale and complexity of energy-saving projects, the role of engineers has evolved beyond pure technical implementation to encompass regulatory compliance, performance verification, responsibility delineation and risk judgement in practical engineering contexts.\n\n" +

"This course adopts an engineer-oriented approach to provide a structured overview of the regulatory background of modern building energy efficiency engineering, major and emerging energy efficiency technology options, and fair and auditable evidence-based methods for demonstrating energy performance outcomes. Quantum Optimization Technology (QOT), an energy-saving technology that has seen wider application in recent years, will be used as a representative case to illustrate how engineers can understand the underlying technical principles, assess applicability conditions, and reasonably interpret energy performance results in real engineering environments.\n\n" +

"The course further extends to emerging practical trends, including changes in statutory inspection requirements, the relationship between pre-project simulation and statutory inspections, performance shortfall-related risk considerations, and the impact of financial arrangements and ESG frameworks on engineering responsibility and verification requirements.\n\n" +

"This course is designed as a Continuing Professional Development (CPD) activity to enhance engineers’ professional judgement, competence and risk awareness in building energy efficiency engineering.",
      formLink:
        "https://forms.gle/qPiQVUMvfo6PLRKe9",
      showSessions: false,
      sessions: [
        {
          month: "July",
          date: "26 July 2026 (Sun)",
          time: "2:00 pm-5:00 pm",
          code: "CPD0714/2026",
          fee: "$500",
        },
      ],
    },
    {
      ref_no: "SOCI001-01",
      title: "Legal Case Studies in Engineering Practice (In Person)",
      description:
        "It is designed to provide engineers with a comprehensive understanding of the legal landscape that governs engineering practices. Engineering projects often involve complex legal issues, so professionals must be well-versed in relevant legal principles, case law, and regulatory frameworks. This course will equip participants with the knowledge and skills to navigate legal challenges effectively and make informed decisions that align with engineering standards and legal requirements. A legal case on a recent elevator accident will be shared to illustrate the application.",
      formLink:
        "https://forms.gle/rY8mn6kvfSGZXEPw6",
      showSessions: false,
      sessions: [
        {
          month: "August",
          date: "16 August 2026 (Sun)",
          time: "2:00 pm-6:00 pm",
          code: "CPD0814/2026",
          fee: "$1500",
        },
      ],
    },
    {
      ref_no: "SOCI002-01",
      title: "Machine Learning in Engineering Practice (In Person)",
      description:
        "Machine learning empowers engineers by enhancing decision-making capabilities, automating repetitive tasks, enabling predictive maintenance, optimizing design processes, improving quality control, reducing costs, enhancing customer experience, and providing scalability. These benefits enable engineers to tackle complex challenges more effectively and innovate. Engineering examples of data acquisition by measurements and simulations and subsequent machine learning are illustrated step-by-step in detail.",
      formLink:
        "https://forms.gle/iHokcJuTvstkcGPm6",
      showSessions: false,
      sessions: [
        {
          month: "September",
          date: "20 September 2026 (Sun)",
          time: "2:00 pm-6:00 pm",
          code: "CPD0914/2026",
          fee: "$1500",
        },
      ],
    }
  ];

  toggleSessions(course: any) {
    course.showSessions = !course.showSessions;
  }
}
